export const TOGGLE_TOAST = 'TOGGLE_TOAST';

export function toggleToast(toast){
    return{
        type: TOGGLE_TOAST,
        mainState: {
            toast: toast
        }
    }
}